import { cn } from "@/lib/utils";

const ULThemeFooter = () => {

  const wrapperStyles = cn(
    "theme-universal",
    "fixed w-full bottom-0 right-0"
  );
  const footerStyles = cn(
    "theme-universal:bg-(--color-widget-bg)",
    "text-right pr-2",
  );
  const spanStyles = cn(
    "theme-universal:text-(--color-body-text)"
  )
  const linkStyles = cn(
    "theme-universal:text-(--color-link-focus)",
    "hidden md:inline hover:underline ml-4",
  );

  return (
    <div className={wrapperStyles}>
      <footer className={footerStyles}>
        <span className={spanStyles}>
          © Oskar.de GmbH {new Date().getFullYear()}
        </span>
        <a href="https://www.oskar.de/kontakt/" className={linkStyles}>
          Kontakt
        </a>
        <a href="https://www.oskar.de/impressum/" className={linkStyles}>
          Impressum
        </a>
        <a href="https://www.oskar.de/datenschutz/" className={linkStyles}>
          Datenschutz
        </a>
        <a href="https://www.oskar.de/agb/" className={linkStyles}>
          AGB
        </a>
        <a href="https://www.oskar.de/risikohinweise/" className={linkStyles}>
          Risikohinweise
        </a>
      </footer>
    </div>
  );
};

export default ULThemeFooter;